<template>
  <div class="showFiles">
    <div class="file-item" v-for="(item, index) in imgData" :key="index">
      <img
        v-if="handelLastName(_getDownloadUrl(item))"
        style="width: 30px; height: 30px"
        :z-index="5000"
        :src="_getDownloadUrl(item)"
        @click.stop="onPreviewImg(imgData, _getDownloadUrl(item))"
      />
      <i v-if="!handelLastName(_getDownloadUrl(item))" class="el-icon-document"></i>
      <a v-if="!handelLastName(_getDownloadUrl(item))" :href="_getDownloadUrl(item)" :download="_getDownloadUrl(item)">{{
        getFileName(item).model
      }}</a>
    </div>
    <el-image-viewer :initialIndex="curIndex" v-if="showViewerImg" :on-close="closeViewer" :url-list="url" :z-index="5000" />
  </div>
</template>

<script>
import mixins from './mixins'
import ElImageViewer from 'dygc-ui/packages/image/src/image-viewer'

export default {
  name: 'showFiles',
  mixins: [mixins],
  components: { ElImageViewer },

  data() {
    return {
      fileList: [],
      showViewerImg: false,
      url: [],
      curIndex: 0
    }
  },
  props: {
    imgData: {
      type: Array,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    getFileName() {
      return function (url) {
        // let index = url.lastIndexOf('\/')
        let str = this.convertFileName(url)
        return { model: str }
      }
    }
  },
  methods: {
    convertFileName(filename = '') {
      filename = decodeURIComponent(filename)
      const splits = filename.split('/')
      filename = splits.pop()
      if (filename.indexOf('_')) {
        let [, ...names] = filename.split('_')
        filename = names.join('_')
      }
      return filename
    },
    // 关闭查看器
    closeViewer() {
      this.showViewerImg = false
    },
    handelLastName(item) {
      const reg = /\.(jpg|png|gif|bmp|jpeg|ico|svg|tiff|tif|webp)$/i; 
      return reg.test(item)
    },
    onPreviewImg(imgList, item) {
      this.url = []
      imgList.forEach(element => {
        this.handelLastName(element) && this.url.push(this._getDownloadUrl(element))
      })
      this.curIndex = this.url.findIndex(it => {
        return it == item
      })
      this.showViewerImg = true
    }
  }
}
</script>

<style lang="scss" scoped>
.showFiles {
  width: 100%;
  .file-item {
    display: inline-block;
    cursor: pointer;
    border: 1px solid rgb(235, 238, 245);
    a {
      padding: 2px 5px;
      border-radius: 2px;
    }
  }
  .file-item:hover {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  }
}
</style>
